import "/__w/1/s/BotFramework-WebChat/packages/component/src/providers/CustomElements/customElements/CodeBlock.module_built.css";
const classes = {"code-block__body":"wWoZ38W_code-block__body","code-block__theme--github-dark-default":"wWoZ38W_code-block__theme--github-dark-default","code-block":"wWoZ38W_code-block","code-block__theme--github-light-default":"wWoZ38W_code-block__theme--github-light-default"}
export default classes

const _code_block__body0 = classes["code-block__body"]
export { _code_block__body0 as "code-block__body" }

const _code_block__theme__github_dark_default0 = classes["code-block__theme--github-dark-default"]
export { _code_block__theme__github_dark_default0 as "code-block__theme--github-dark-default" }

const _code_block0 = classes["code-block"]
export { _code_block0 as "code-block" }

const _code_block__theme__github_light_default0 = classes["code-block__theme--github-light-default"]
export { _code_block__theme__github_light_default0 as "code-block__theme--github-light-default" }
